/*
 * Recherche : matching par préfixe sur la page /search
 * --------------------------------------------------------------
 * La recherche prédictive du header (API /search/suggest) fait un
 * matching par préfixe : « ferro » trouve « Ferrovissime ». La
 * recherche standard de la page /search ne le fait pas, même avec
 * options[prefix]=last. Le seul levier qui fonctionne côté standard
 * est le wildcard `*` (ex. « ferro* »).
 *
 * Ce script suffixe automatiquement `*` au terme saisi juste avant
 * l'envoi du formulaire de recherche, pour aligner la page sur le
 * dropdown. L'astérisque est ensuite retiré à l'affichage côté Liquid
 * (main-search.liquid / search-actions.liquid).
 */
(function () {
  if (window.__lrSearchWildcard) return;
  window.__lrSearchWildcard = true;

  document.addEventListener(
    "submit",
    function (event) {
      var form = event.target;
      if (!(form instanceof HTMLFormElement)) return;

      var action = form.getAttribute("action") || "";
      if (action.indexOf("/search") === -1) return;

      var input = form.querySelector('input[name="q"]');
      if (!input) return;

      var value = input.value.trim();
      if (!value) return;

      // On respecte les recherches déjà ciblées : wildcard déjà présent,
      // phrase exacte ("..."), ou filtre par champ (ex. vendor:LR PRESSE).
      if (/[*":]/.test(value)) return;

      input.value = value + "*";
    },
    true
  );
})();
